import { format, isDate } from 'date-fns';

export const parseObjectToSearchParams = <
  T extends object = Record<string, string | object | boolean | number | undefined>,
>(
  args: T
): T => {
  return Object.entries(args).reduce((acc, [key, value]) => {
    let parsedValue: unknown;

    if (Array.isArray(value)) {
      parsedValue = value.filter((val) => String(val).trim().length).join(',');
    } else if (isDate(value)) {
      parsedValue = format(value, 'yyyy-MM-dd');
    } else if (typeof value === 'object' && value !== null) {
      const hasAnyValue = Object.values(value).join('').trim().length > 0;

      parsedValue = hasAnyValue ? parseObjectToSearchParams(value) : undefined;
    } else if (typeof value === 'boolean') {
      parsedValue = value;
    } else if (typeof value === 'number') {
      parsedValue = Number.isNaN(value) ? undefined : value;
    } else if (typeof value === 'string' && value.trim().length) {
      parsedValue = value;
    }

    acc[key as keyof T] = parsedValue as T[keyof T];
    return acc;
  }, {} as T);
};
